export var EmbedContext;
(function (EmbedContext) {
    EmbedContext["INLINE"] = "EmbedContext.INLINE";
    EmbedContext["IFRAME_MVP"] = "EmbedContext.IFRAME_MVP";
    EmbedContext["IFRAME_SCRIPTED"] = "EmbedContext.IFRAME_SCRIPTED";
})(EmbedContext || (EmbedContext = {}));
